import {immerable} from "immer";
import StoreyCreationModel from "./storey-creation-model.ts";
import FileDataCreationModel from "@/components/create-project-dialog/models/file-data-creation-model.ts";
import FileType from "@/models/enums/file-type.ts";

class BuildingCreationModel {
    [immerable] = true;
    
    id: string;

    name = "";
    
    index = 0;

    storeys: StoreyCreationModel[] = [];
    
    files3d: FileDataCreationModel[] = [];

    constructor(name = "", storeys: StoreyCreationModel[] = [], index = 0) {
        this.id = crypto.randomUUID();
        this.name = name;
        this.storeys = storeys;
        this.index = index;

        this.files3d.push(new FileDataCreationModel(`2D3D-${this.name}.ifc`, FileType.File3DFrom2D));
    }
}

export default BuildingCreationModel;
